import { useTheme } from 'styled-components';
import { Onboard as SharedOnboard } from '@make-software/tg-mini-app-ui';

import StepOneImage from '@/shared/assets/onboarding/onboarding-first.png';
import StepTwoImage from '@/shared/assets/onboarding/onboarding-second.png';
import StepThreeImage from '@/shared/assets/onboarding/onboarding-third.png';
import { useMe } from '@/shared';

type OnboardingData = {
  title: string;
  subtitle?: string;
  banner: string;
};

const onboardingData: OnboardingData[] = [
  {
    title: 'Earn fan points every day',
    subtitle:
      "Complete daily tasks to earn fan points. New day, new tasks. You can find all daily challenges on the 'Earn' page.",
    banner: StepOneImage
  },
  {
    title: 'Invite friends and earn fan points',
    subtitle: 'The more friends you invite, the more fan points you earn.',
    banner: StepTwoImage
  },
  {
    title: 'Connect your wallet easily',
    subtitle: 'Connect your Wallet to be ready to participate in TEA rewards',
    banner: StepThreeImage
  }
];

export const OnBoard = () => {
  const meService = useMe();
  const theme = useTheme();

  return (
    <SharedOnboard
      slides={onboardingData}
      onComplete={meService.completeOnboarding}
      background="linear-gradient(180deg, #2c4f45 0%, #0a0710 100%)"
      progressColor="#74FAD1"
      buttonHoverBackgroundColor={theme.colors.mainGreen}
      contentMaxWidth="90%"
      progressDurationMs={3000}
      buttonTitle="Continue"
      finalButtonTitle="Get started"
    />
  );
};
